import React from "react";
import {
  Utensils, BedDouble, Shirt, Footprints, Gem, Scissors, Smartphone,
  Stethoscope, Pill, GraduationCap, ShoppingCart, Cake, Dumbbell,
  Wrench, PartyPopper, Store,
  Wind, Zap, Hammer, Paintbrush, Car, Laptop, Refrigerator, Plug,
  Sparkles, Frame, HardHat, Sofa, Key, Camera, Palette, Truck, Package,
} from "lucide-react";

const MAP = {
  utensils: Utensils, "bed-double": BedDouble, shirt: Shirt, footprints: Footprints,
  gem: Gem, scissors: Scissors, smartphone: Smartphone, stethoscope: Stethoscope,
  pill: Pill, "graduation-cap": GraduationCap, "shopping-cart": ShoppingCart,
  cake: Cake, dumbbell: Dumbbell, wrench: Wrench, "party-popper": PartyPopper, store: Store,
  wind: Wind, zap: Zap, hammer: Hammer, paintbrush: Paintbrush, car: Car, laptop: Laptop,
  refrigerator: Refrigerator, plug: Plug, sparkles: Sparkles, frame: Frame, "hard-hat": HardHat,
  sofa: Sofa, key: Key, camera: Camera, palette: Palette, truck: Truck, package: Package,
};

export const CategoryIcon = ({ icon, className }) => {
  const Comp = MAP[icon] || Store;
  return <Comp className={className} strokeWidth={2} />;
};
